import { useCallback } from 'react';
import { IUseFrameInput } from './frameInput.models';

export const useFrameInput = ({ name, onChange }: IUseFrameInput) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      document.getElementsByName(name).forEach((input) => {
        if (input === e.target) {
          if (e.target.checked) {
            e.target.parentElement?.classList.add('checked');
          } else {
            e.target.parentElement?.classList.remove('checked');
          }
        } else if (input.parentElement?.classList.contains('checked')) {
          input.parentElement?.classList.remove('checked');
        }
      });

      onChange?.(e);
    },
    [name, onChange]
  );

  return {
    handleChange,
  };
};

